import {useDialog} from './useDialog';

export type Feature = 'open-banking-payment-v3' | 'demo_web';

export type FeedbackDialogProps = {pageId: string; feature: Feature};

export const useFeedbackDialog = () => {
  const dialog = useDialog<FeedbackDialogProps>('feedback');
  const show = (props: FeedbackDialogProps) => {
    // only show feedback once per customer per feature
    const key = `skip-feedback-${props.feature}`;
    if (localStorage.getItem(key)) return;
    localStorage.setItem(key, new Date().toISOString());

    dialog.setState({
      type: 'feedback',
      feature: props.feature,
      pageId: props.pageId,
    });
  };

  return {
    open: dialog.open,
    state: dialog.state,
    onClose: dialog.onClose,
    show,
  };
};
